var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card-box3"},[_c('div',{staticClass:"content3"},[_c('h4',[_vm._v("基金报告")]),_vm._v(" "),_vm._l((_vm.teamlist),function(item){return _c('ul',{key:item},[_c('li',[_c('a',{attrs:{"href":'/#/fund/' + item.id}},[_vm._v(_vm._s(item.title))])])])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-913c64ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card3.vue
// module id = null
// module chunks = 